import publicRoutes from './public';

export default Object.freeze({
	...publicRoutes
});
